import { apiRequest } from '@/utils/apiRequest'
import { apiUrl } from '@/utils/apiUrl'
import configModule from '@/store/configModule'

class UserRepository {
	constructor() {
		const host = window.location.hostname
		if (host === 'localhost' || host.startsWith('192.168')) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL
		} else {
			this.urlBase = window.location.origin
		}
	}

	async find(uid) {
		const url = configModule.state.wePassUrl + '/world/api/user/find'
		try {
			const response = await apiRequest({ url, method: 'POST', body: { uid }, throwOnNonOk: false })
			return response.data
		} catch (e) {
			console.log('Ups, algo ha ido mal obteniendo la informacion del usuario.')
		}
	}

	async checkEmail(email, noMail) {
		const url = configModule.state.wePassUrl + '/world/user/remindnumber'
		try {
			const response = await apiRequest({ url, method: 'POST', body: { email, noMail }, throwOnNonOk: true })
			return response.data
		} catch (e) {
			console.log('Ups, algo ha ido mal obteniendo la informacion del usuario.')
		}
	}

	async registerUserFromInvitation(data) {
		try {
			const response = await apiRequest({ url: apiUrl('/world/user/register'), method: 'POST', body: data, throwOnNonOk: false })
			return response.data
		} catch (e) {
			console.log('Ups, algo ha ido mal terminando creando el usuario por invitacion')
		}
	}

	async createGuestUserMenu(data) {
		try {
			const response = await apiRequest({ url: apiUrl('/world/api/user/createguestusermenu'), method: 'POST', body: data, throwOnNonOk: false })
			return response.data
		} catch (e) {
			console.log('Ups, algo ha ido mal terminando creando el usuario invitado para el menu')
		}
	}

	async sendPass(uid) {
		try {
			const response = await apiRequest({ url: apiUrl('/world/api/user/sendpass'), method: 'POST', body: { uid }, throwOnNonOk: false })
			return response.data
		} catch (e) {
			console.log('Ups, algo ha ido mal enviando el pass')
		}
	}

	async getReservationsUser(uid) {
		const response = await apiRequest({ url: apiUrl('/world/reservation/userfuture'), method: 'POST', body: { uid }, throwOnNonOk: false })
		return response.data
	}

	async registerLog(data) {
		try {
			const response = await apiRequest({ url: apiUrl('/world/doorlog/register'), method: 'POST', body: data, throwOnNonOk: false })
			return response.data
		} catch (e) {
			console.log('Ups, algo ha ido mal registrando el log')
		}
	}

	async checkLog(welkhomeKey, userId) {
		const currentDate = new Date()
		const limitDate = new Date(currentDate)
		limitDate.setDate(currentDate.getDate() - 1)
		const body = {
			welkhomeKey: welkhomeKey,
			dateFrom: limitDate,
			dateTo: currentDate,
			userId: userId
		}
		try {
			const response = await apiRequest({ url: apiUrl('/world/doorlog/history'), method: 'POST', body, throwOnNonOk: true })
			return response.data
		} catch (e) {
			console.log('Ups, algo ha ido mal consultando los logs')
		}
	}

	async updateAllergens(uid, allergensId) {
		try {
			const response = await apiRequest({ url: apiUrl('/world/api/user/updateallergens'), method: 'POST', body: { uid, allergensId }, throwOnNonOk: false })
			return response.data
		} catch (e) {
			console.log('Ups, algo ha ido mal actualizando las alergias del usuario')
		}
	}

	async sendComment(uid, comment) {
		try {
			const response = await apiRequest({ url: apiUrl('/world/api/webcontact/sendcomment'), method: 'POST', body: { uid, comment }, throwOnNonOk: false })
			return response.data
		} catch (e) {
			console.log('Ups, algo ha ido mal enviando el comentario')
		}
	}

	async login(userEmail, password) {
		try {
			const response = await apiRequest({ url: apiUrl('/world/api/user/login'), method: 'POST', body: { userEmail, password }, token: null, throwOnNonOk: false })
			return response.data
		} catch (e) {
			console.log('Ups, algo ha ido mal logeando al usuario', e)
		}
	}

	async loginWithToken(token, app = null) {
		const path = '/world/api/user/check-access' + (app ? `?app=${app}` : '')
		try {
			const response = await apiRequest({ url: apiUrl(path), method: 'GET', token, throwOnNonOk: false })
			if (!response.ok) return null
			return response.data
		} catch (e) {
			console.log('Ups, algo ha ido mal logeando al usuario con token', e)
			return null
		}
	}

	async loginCopilot(userEmail, password) {
		try {
			const response = await apiRequest({
				url: apiUrl('/world/api/user/login-app'),
				method: 'POST',
				body: { userEmail, password, appContext: 'copilot' },
				token: null,
				throwOnNonOk: false,
			})
			return response.data
		} catch (e) {
			console.log('Ups, algo ha ido mal logeando al usuario en copilot', e)
		}
	}

	async updateUserName(userName) {
		try {
			const response = await apiRequest({ url: apiUrl('/world/api/user/update-user-name'), method: 'POST', body: { userName } })
			return response.data
		} catch (e) {
			console.log('Ups, algo ha ido mal actualizando el nombre del usuario', e)
		}
	}
}

export const userRepository = new UserRepository()
